import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from "primereact/panel";
import { Chip } from "primereact/chip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import "../Protestos.css";
 
type ProtestosProps = {
  cartorios: any;
};
 
export default function Protestos({ cartorios }: ProtestosProps) {
  const { t } = useTranslation();
 
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className}`;
    return (
      <div className={className}>
        {cartorios ? (
          <span
            style={{ color: "#C70039", fontSize: "1.5rem" }}
            className="pi pi-exclamation-triangle"
          >
            <span
              className="p-panel-title"
              style={{
                marginLeft: "1rem",
                fontFamily: "var(--font-family)",
                fontSize: "1rem",
                color: "black",
              }}
            >
              {t("protestos")}
            </span>
          </span>
        ) : (
          <span
            className="p-panel-title"
            style={{
              marginLeft: "1rem",
              fontFamily: "var(--font-family)",
              fontSize: "1rem",
              color: "black",
            }}
          >
            {t("protestos")}
          </span>
        )}
      </div>
    );
  };
 
  return (
    <Panel headerTemplate={headerTemplate}>
      {!cartorios && <NadaConsta />}
 
      {cartorios &&
        cartorios.map((cartorio: any, index: number) => (
          <div key={index}>
            {/* Cards de resumo – só no primeiro cartório */}
            {index === 0 && cartorios[0].resumos && (
              <div className="protestos-cards">
                {cartorios[0].resumos.map((item: any, idx: number) => (
                  <Card key={idx} className="protestos-card">
                    <div className="protestos-card-content">
                      <div className="protestos-card-text">
                        <span className="protestos-card-label">
                          {item.label}
                        </span>
                        <span className="protestos-card-value">
                          {item.value}
                        </span>
                      </div>
                      <span className="protestos-card-icon">
                        <i className={item.icon} />
                      </span>
                    </div>
                  </Card>
                ))}
              </div>
            )}
 
            <br />
            <br />
 
            <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                <div>
                  <label className="label-dados">{t("cartorio")}</label>
                  <Chip style={{ width: "100%" }} label={cartorio.nome} />
                </div>
              </div>
              <div className="col">
                <div>
                  <label className="label-dados">{t("quantidade")}</label>
                  <Chip
                    style={{ width: "100%" }}
                    label={cartorio.quantidade}
                  />
                </div>
              </div>
            </div>
 
            <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                <div>
                  <label className="label-dados">{t("uf")}</label>
                  <Chip style={{ width: "100%" }} label={cartorio.uf} />
                </div>
              </div>
              <div className="col">
                <div>
                  <label className="label-dados">{t("fone")}</label>
                  <Chip style={{ width: "100%" }} label={cartorio.telefone} />
                </div>
              </div>
            </div>
 
            <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                <div>
                  <label className="label-dados">{t("endereco")}</label>
                  <Chip style={{ width: "100%" }} label={cartorio.endereco} />
                </div>
              </div>
            </div>
 
            {cartorio.protestos && (
              <>
                <br />
                <div className="protestos-table-wrapper">
                  <DataTable
                    size="small"
                    value={cartorio.protestos}
                  >
                    <Column field="data" header={t("data")} />
                    <Column field="valor" header={t("valor")} />
                  </DataTable>
                </div>
                <br />
                <br />
                <br />
              </>
            )}
          </div>
        ))}
    </Panel>
  );
}